import React from '../vendor/react';
import { useEffect, useState } from '../vendor/react';
import { QueryClient, QueryClientProvider } from '../vendor/react-query';
import { RouterProvider } from '../vendor/react-router-dom';
import { initializeAuth, useAuth } from '../features/auth/auth-store';
import { initializeOfflineEngine } from '../features/offline/offline-engine';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

export function App() {
  const auth = useAuth();
  const [offlineReady, setOfflineReady] = useState(false);

  useEffect(() => { void initializeAuth(); }, []);
  useEffect(() => {
    if (auth.status !== 'ready') {
      setOfflineReady(false);
      return;
    }
    let active = true;
    setOfflineReady(false);
    void initializeOfflineEngine().finally(() => { if (active) setOfflineReady(true); });
    return () => { active = false; };
  }, [auth.status, auth.session?.user.id, auth.workspace?.activeContext?.organizationId]);

  if (auth.status !== 'ready' || !offlineReady) {
    return <div className="auth-loading"><span className="loading-spinner" /><p>Sincronizando primero con Supabase…</p></div>;
  }

  return <QueryClientProvider client={queryClient}><RouterProvider router={router} /></QueryClientProvider>;
}
